import styled from 'styled-components';

export const UserRowContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 3px 0;
    margin-bottom: 10px;
`;

export const UserName = styled.div`
    margin-left: 19px;
    flex: 1;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/PlainUserRow/style.js